import { render } from "@testing-library/react";
import ToolTip from "../../ToolTip/ToolTip";

const handleAssign = (params) => {
  return (
    <ToolTip content={params.row.description} expand={params.row.description} />
  );
};

export const Permission_Table_Head = [
  {
    field: "sl_no",
    headerName: "Sl No",
  },
  {
    field: "permissionID",
    headerName: "Permission ID",
    width: 120,
  },
  {
    field: "title",
    headerName: "Title",
    width: 200,
  },
  {
    field: "path",
    headerName: "Path",
    width: 300,
  },
  {
    field: "description",
    headerName: "Description",
    width: 300,
    renderCell: handleAssign,
  },
  {
    field: "department",
    headerName: "Department",
    width: 200,
  },
  {
    field: "module",
    headerName: "Module",
    width: 200,
  },
  {
    field: "menuItem",
    headerName: "Menu Item",
    width: 150,
    renderCell: (params) => {
      if (params.row.menuItem === 0) {
        return "Sidebar";
      } else {
        return "Other";
      }
    },
  },
  {
    field: "created_on",
    headerName: "Created On",
    width: 200,
  },
  {
    field: "edited_on",
    headerName: "Edited On",
    width: 200,
  },

  {
    field: "created",
    headerName: "Created By",
    width: 200,
  },
  {
    field: "edited",
    headerName: "Edited By",
    width: 200,
  },
];
